import styled from "styled-components";

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.cardBg ?? theme.colors.white};
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight ?? "#E5E7EB"};
  box-shadow: 0 2px 12px rgba(16, 24, 64, 0.08);
`;

export const HeaderSection = styled.div`
  padding: 0 24px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borderLight};
  flex-shrink: 0;
`;





export const HeaderTopRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 12px;
`;

export const TabsRow = styled.div`
  .ant-tabs {
    margin-bottom: 0;
  }
  .ant-tabs-nav {
    margin-bottom: 0 !important;
  }
  .ant-tabs-tab {
    padding: 8px 0 !important;
  }
 
  .ant-tabs-ink-bar {
    background: ${({ theme }) => theme.colors.primary} !important;
  }
`;

export const TabLabelWithCaret = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

export const ContentSection = styled.div`
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 16px 24px 24px;
`;

export const RoleImpactGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  height: 100%;
  min-height: 0;
  align-items: stretch;

  .ant-card {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .ant-card-body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
    overflow: auto;
  }
`;

export const StyledCard = styled.div`
  height: 100%;
  min-height: 0;
  border-radius: 12px;

  .ant-card-head {
    display: none;
  }
  .ant-card-body {
    height: 100%;
    min-height: 0;
    padding: 16px !important;
    display: flex;
    flex-direction: column;
  }
`;

export const SectionTitle = styled.h4`
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.dark};
`;

export const SectionSubTitle = styled.p`
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.gray};
`;

export const RoleDescription = styled.div`
  margin-bottom: 8px;
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.light};
`;

export const RoleCharterText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: ${({ theme }) => theme.colors.dark};
  font-weight: 500;

  strong {
    color: ${({ theme }) => theme.colors.dark};
    font-weight: 700;
  }
`;

export const ScrollableContent = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 1rem;
  scroll-behavior: smooth;
  padding-right: 4px;


  
`;

export const DetailBlock = styled.div`
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: ${({ $last }) =>
    $last ? "none" : `1px solid ${({ theme }) => theme.colors.borderLight}`};

  &:last-child {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
  }
`;

export const DetailLabel = styled.h6`
  margin: 0 0 6px;
  font-size: 12px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dark};
`;

export const DetailText = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
`;

export const WorkflowList = styled.ol`
  margin: 0;
  padding-left: 20px;

  li {
    margin-bottom: 6px;
    font-size: 14px;
    line-height: 1.55;
  }
  li:last-child {
    margin-bottom: 0;
  }
`;

export const OverallStats = styled.div`
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.light};
  flex-shrink: 0;
`;

export const OverallStatsTitle = styled.h6`
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.2;
`;

export const StatRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
`;

export const StatLabel = styled.div`
  min-width: 92px;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.dark};
`;

export const ProgressBarTrack = styled.div`
  flex: 1;
  display: flex;
  height: 24px;
  overflow: hidden;
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.borderLight};
`;

export const ProgressBarPeople = styled.div`
  width: ${({ $width }) => `${$width}%`};
  min-width: ${({ $width }) =>
    (Number($width) || 0) > 0 ? "fit-content" : "0"};
  padding: ${({ $width }) => ((Number($width) || 0) > 0 ? "0 8px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.progressBarPeople};
  color: ${({ theme }) => theme.colors.white};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
`;

export const ProgressBarAI = styled.div`
  width: ${({ $width }) => `${$width}%`};
  min-width: ${({ $width }) =>
    (Number($width) || 0) > 0 ? "fit-content" : "0"};
  padding: ${({ $width }) => ((Number($width) || 0) > 0 ? "0 8px" : "0")};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.progressBarAI};
  color: ${({ theme }) => theme.colors.dark};
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
`;

export const MetricsList = styled.div`
  display: grid;
  gap: 6px;
`;

export const MetricCard = styled.div`
  padding: 6px 10px;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const MetricTextGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

export const MetricTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.dark};
  line-height: 1.3;
`;

export const MetricFormula = styled.div`
  margin-top: 2px;
  font-size: 12px;
  line-height: 1.35;
  color: ${({ theme }) => theme.colors.gray};
  font-weight: 500;
`;

export const MetricValue = styled.div`
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.primary};
  white-space: nowrap;
  line-height: 1;
`;

export const ViewMoreButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
`;

export const ComparisonHeader = styled.div`
  flex-shrink: 0;
  margin-bottom: 8px;
`;

export const ComparisonTableWrap = styled.div`
  max-height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  background: ${({ theme }) => theme.colors.white};
 
`;

export const ComingSoonText = styled.p`
  margin: 0;
  padding: 48px 24px;
  text-align: center;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const LoadingContainer = styled.div`
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyStateWrap = styled.div`
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
